import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Empresa } from '../../entities/empresa';
import { Api } from '../../providers/api/api';

import * as _ from 'lodash';

interface IndicadorFaturamentoMultiloja {
    QuantidadePecaDia: number;
    ValorLiquidoDia: number;
    PrecoMedioDia: number;
    QuantidadePecaMes: number;
    ValorLiquidoMes: number;
    PrecoMedioMes: number;
    QuantidadePecaAno: number;
    ValorLiquidoAno: number;
    PrecoMedioAno: number;
    Empresa: Empresa;
}

@Component({
    selector: 'indicador-fat-multilojas',
    templateUrl: 'indicador-fat-multilojas.html'
})
export class IndicadorFaturamentoMultilojasComponent implements OnInit, OnDestroy {
    @Input('analytic') analytic: boolean = false;

    public data: Date = new Date();

    public faturamentoMultilojaDilady: IndicadorFaturamentoMultiloja;
    public faturamentoMultilojaLoveSecret: IndicadorFaturamentoMultiloja;
    public faturamentoMultilojaBanhoDeMar: IndicadorFaturamentoMultiloja;
    public faturamentoMultilojaDoctorSecret: IndicadorFaturamentoMultiloja;
    public faturamentoMultilojaGrupo: any;

    public carregandoDados: boolean = true;

    private _myInterval: number;

    constructor(
        private _api: Api
    ) { }

    public ngOnInit(): void {
        this._separarLojas();

        this._myInterval = setInterval(() => {
            this._separarLojas();
        }, 30000);
    }

    public ngOnDestroy(): void {
        clearInterval(this._myInterval);
    }

    private _separarLojas(): void {
        this._obterIndicadorFaturamentoMultiloja().then(indicadores => {
            this.faturamentoMultilojaDilady = indicadores.find(a => _.isEqual(a.Empresa.Id, 1));
            this.faturamentoMultilojaLoveSecret = indicadores.find(a => _.isEqual(a.Empresa.Id, 2));
            this.faturamentoMultilojaBanhoDeMar = indicadores.find(a => _.isEqual(a.Empresa.Id, 3));
            this.faturamentoMultilojaDoctorSecret = indicadores.find(a => _.isEqual(a.Empresa.Id, 5));

            this.faturamentoMultilojaGrupo = {
                QuantidadePecaDia: _.sum(indicadores.map(a => a.QuantidadePecaDia)),
                ValorLiquidoDia: _.sum(indicadores.map(a => a.ValorLiquidoDia)),
                PrecoMedioDia: 0,
                QuantidadePecaMes: _.sum(indicadores.map(a => a.QuantidadePecaMes)),
                ValorLiquidoMes: _.sum(indicadores.map(a => a.ValorLiquidoMes)),
                PrecoMedioMes: 0,
                QuantidadePecaAno: _.sum(indicadores.map(a => a.QuantidadePecaAno)),
                ValorLiquidoAno: _.sum(indicadores.map(a => a.ValorLiquidoAno)),
                PrecoMedioAno: 0
            }

            if (!isNaN(this.faturamentoMultilojaGrupo.ValorLiquidoDia / this.faturamentoMultilojaGrupo.QuantidadePecaDia))
                this.faturamentoMultilojaGrupo.PrecoMedioDia = (this.faturamentoMultilojaGrupo.ValorLiquidoDia / this.faturamentoMultilojaGrupo.QuantidadePecaDia);
            if (!isNaN(this.faturamentoMultilojaGrupo.ValorLiquidoMes / this.faturamentoMultilojaGrupo.QuantidadePecaMes))
                this.faturamentoMultilojaGrupo.PrecoMedioMes = (this.faturamentoMultilojaGrupo.ValorLiquidoMes / this.faturamentoMultilojaGrupo.QuantidadePecaMes);
            if (!isNaN(this.faturamentoMultilojaGrupo.ValorLiquidoAno / this.faturamentoMultilojaGrupo.QuantidadePecaAno))
                this.faturamentoMultilojaGrupo.PrecoMedioAno = (this.faturamentoMultilojaGrupo.ValorLiquidoAno / this.faturamentoMultilojaGrupo.QuantidadePecaAno);

            setTimeout(() => {
                this.carregandoDados = false;
            }, 1000);
        }).catch(error => {
            console.error(error);
        });
    }

    private _obterIndicadorFaturamentoMultiloja(): Promise<IndicadorFaturamentoMultiloja[]> {
        return new Promise((resolve, reject) => {
            this._api.get('IndicadorFaturamentoMultiloja').subscribe(response => resolve(JSON.parse(response._body)), reject);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/indicador-fat-multilojas/indicador-fat-multilojas.ts